import { render } from "./recipientsComponents.vue?vue&type=template&id=3151bad4&scoped=true"
import script from "./recipientsComponents.vue?vue&type=script&lang=js"
export * from "./recipientsComponents.vue?vue&type=script&lang=js"

import "./recipientsComponents.vue?vue&type=style&index=0&id=3151bad4&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3151bad4"]])

export default __exports__